export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/success.0e97b36c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};